<h1>{{mainText}}</h1>
<br>
<div style="width: 100%; text-align:center;">
  <button (click)="OnButton(true)">{{confirmText}}</button>
  <button *ngIf="canCancel;" (click)="OnButton(false)">{{cancelText}}</button>
</div>
